import moment from 'moment-timezone'

export default ({ value }) => moment(value).format('HH:mm')
